import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

document.addEventListener("DOMContentLoaded", () => {
  const mountId = window.ReactMountDiv || "react-root";
  const rootElement = document.getElementById(mountId);

  if (rootElement) {
    try {
      const root = ReactDOM.createRoot(rootElement);
      root.render(<App />);
    } catch (err) {
      console.error("🔥 React failed to mount:", err);
    }
  } else {
    console.warn(`🚨 Mount point #${mountId} not found.`);
  }
});
